import FormInputTypes from '../../components/atoms/formEnums/formInputTypes';
import routes from '../../routes/route';

export default {
  attributeName: 'homeConfigsTable',
  isDragable: false,
  canOpen: false,
  canEdit: false,
  canCreate: false,
  canRemove: false,
  isMultiSelectable:false,
  newButton:false,
  getURL: routes.MH_CONFIG_EDIT,

  // getURL:'graphicmanagers/historic',
  removeURL:'graphicmanagers/historic',

  sessionParams: [],

  emptyMessage: "You don't have any Config defined under this app.",
  fields: [
    {
      attributeName: 'name',
      label: 'Name',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      default: '',
      canOrder: false,
      canEdit: true,
      canCreate: true,
      canFilter: false,
      helpText: 'Name of the config.',
    },
      {
      attributeName: 'operatingSystem',
      label: 'Operating System',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      default: '',
      canOrder: false,
      canEdit: true,
      canCreate: true,
      canFilter: false,
      helpText: 'Name of the operating system.',
    }, 
    {
      attributeName: 'total',
      label: 'Total visible contents',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      default: '',
      canOrder: false,
      canEdit: true,
      canCreate: true,
      canFilter: false,
      helpText: 'total of the visible contents of the config.',
    }

  ],
};
